import Grid from '@mui/material/Grid';
import { HTMLAttributes } from 'react';

interface FieldProps extends HTMLAttributes<HTMLDivElement> {
    size: number | { xs?: number; md?: number; lg?: number; xl?: number; sm?: number };
}

export function Field(props: FieldProps) {
    return <Grid size={{ xs: props.size }} {...props} />;
}
